import { useState } from "react";
import {
    BrowserRouter as Router, Route, Switch
} from "react-router-dom";
import { IAppInfo } from "../App";
import getMobileOperatingSystem from "../helpers/getMobileOperationSystem";
import { IMainScreenProps, MainScreenContainer, MainScreenContainerWithPromo } from "../MainScreenContainer";
import MainScreenMobileContainer, { MainScreenMobileContainerWithPromo } from "../MainScreenMobileContainer";
import AppPromoItem from "./items/apppromo/AppPromoItem";
import CarsItem from "./items/cars/CarsItem";
import CasesItem from "./items/cases/CasesItem";
import FaqItem from "./items/faq/FaqItem";
import { FeaturesItem } from "./items/features/FeaturesItem";
import InstagramItem from "./items/instagram/InstagramItem";
import MobileChatScreen from "./items/promo/MobileChatScreen";
import MobilePromoItem from "./items/promo/MobilePromoItem";
import PromoItem from "./items/promo/PromoItem";
import SecurityItem from "./items/security/SecurityItem";
import ZonesItem from "./items/zones/ZonesItem";
import './MainScreen.css';
import { ICity } from "./model/B2CInfo";
import MobileZonesView from "./zones/mobile/MobileZonesView";

export default function MainScreen(appInfo: IAppInfo) {
    const b2cInfo = appInfo.b2cInfo;
    const session = appInfo.session;

    let [city, setCity] = useState(b2cInfo.cities[0]!)
    let [showZones, setShowZones] = useState(false);

    let mobileOperationSystem = getMobileOperatingSystem()
    let isMobile = mobileOperationSystem !== "unknown"

    let pathname = window.location.pathname
    let isLight = pathname.endsWith("light") || pathname.endsWith("light/")

    if (isLight) {
        const lightSections = ["promo", "app_promo"]
        city.sections = city?.sections?.filter((value) => lightSections.includes(value.id))
    }

    const sections = city?.sections.map((section) => {
        if (section.id === "cases") {
            return <CasesItem
                key={section.id}
                section={section}
                models={new Map(Object.entries(b2cInfo.models))}
                offers={new Map(Object.entries(b2cInfo.offers))}
                features={new Map(Object.entries(b2cInfo.features))}
                mobile={isMobile}/>;
        } else if (section.id === "promo") {
            return isMobile ?
                <MobilePromoItem key={city.name} city={city} onSelected={(c) => setCity(c)} section={section}
                                 constants={b2cInfo.constants}
                                 session={session}/> :
                <PromoItem key={city.name} section={section} session={session}/>
        } else if (section.id === "zones") {
            return <ZonesItem key={section.id} city={city} constants={b2cInfo.constants} section={section}
                              mobile={isMobile} onShowZones={() => setShowZones(true)}/>
        } else if (section.id === "cars") {
            return <CarsItem key={section.id} mobile={isMobile} section={section}
                             models={new Map(Object.entries(b2cInfo.models))}/>
        } else if (section.id === "features") {
            return <FeaturesItem key={section.id} section={section} features={new Map(Object.entries(b2cInfo.features))}
                                 mobile={isMobile}/>
        } else if (section.id === "security") {
            return <SecurityItem key={section.id} section={section} mobile={isMobile}/>
        } else if (section.id === "app_promo") {
            return <AppPromoItem key={section.id} constants={b2cInfo.constants} section={section} mobile={isMobile}/>
        } else if (section.id === "faq") {
            return <FaqItem key={section.id} section={section} mobile={isMobile}/>
        } else if (section.id === "instagram") {
            return <InstagramItem key={section.id} section={section} mobile={isMobile}/>
        } else {
            return <br/>;
        }
    });

    const mainProps: IMainScreenProps = {
        b2cInfo: b2cInfo!,
        city: city,
        isLight: isLight,
        isMobile: isMobile,
        sections: sections,
        session: session,
        setCity(city: ICity) {
            setCity(city)
        }
    }

    if (isMobile) {
        return (
            <Router>
                <Switch>
                    <Route path="/drive/b2c/zones/">
                        <div style={{width: "100%", height: "100%"}}>
                            <MobileZonesView city={city} constants={b2cInfo.constants}/>
                        </div>
                    </Route>
                    <Route path="/drive/b2c/chat/">
                        <div style={{width: "100%", height: "100%"}}>
                            <MobileChatScreen/>
                        </div>
                    </Route>
                    <Route path="**/promocode/:code">
                        <MainScreenMobileContainerWithPromo {...mainProps}/>
                    </Route>
                    <Route>
                        <MainScreenMobileContainer {...mainProps}/>
                    </Route>
                </Switch>
            </Router>
        );
    } else {
        return <Router>
            <Switch>
                <Route path="**/promocode/:code">
                    <MainScreenContainerWithPromo mainProps={mainProps}/>
                </Route>
                <Route>
                    <MainScreenContainer {...mainProps}/>
                </Route>
            </Switch>
        </Router>
    }
}